import {
  BANNER_DATA,
  ADVANTAGES_EFFECT,
  FEATURES,
  SCENARIO_EFFECT,
  ARCHITECTURE,
  BEST_PRACTICE,
} from '../../utils/const/products/onvideo';

import styles from '../../styles/common.module.scss';
import DetailBanner from '../../components/commonComponents/detailBanner';
import Introduction from '../../components/productPageComponents/introduction';
import Scenarios from '../../components/productPageComponents/scenario';
import Architecture from '../../components/commonComponents/architecture';
import Advantage from '../../components/commonComponents/featureCard';
import UseCase from '../../components/solutionPageComponent/useCase';
import router from 'next/router';

/**
 *
 * @description 快手云剪详情页面
 */

const OnVideo = () => {
  return (
    <>
      <DetailBanner bannerData={BANNER_DATA} />
      <Introduction cards={FEATURES} initialOpen={true} />
      <Advantage advantages={ADVANTAGES_EFFECT} bgColor="#f8f9fa" />
      <Architecture data={ARCHITECTURE} bgColor="#ffffff" />
      <Scenarios scenarios={SCENARIO_EFFECT} bgColor="#f8f9fa" />
      <UseCase useCaseData={BEST_PRACTICE} elementName="best-practice" />
    </>
  );
};

export default OnVideo;
